import React, { FC } from 'react'
import { Flex, VStack } from '@chakra-ui/react'
import { Rw1LogoColored } from '@rw1/shared-lib'
import { Footer } from '../../layout/Footer'

export const Layout: FC<{
  children?: React.ReactNode,
  'data-testid'?: string
  footer?: boolean
}> = ({ children, footer = true }) => {
  return (
    <VStack alignItems="stretch" h="full" overflow="auto" spacing={0} w="full">
      <Flex
        alignItems="center"
        bg="#F2F2F7"
        h="full"
        justifyContent="center"
        p={[0, '80px']}>
        <Flex
          alignItems="center"
          bg="white"
          borderRadius="24px"
          direction="column"
          gridGap="32px"
          maxWidth="400px"
          minHeight="60vh"
          padding="40px"
          textAlign="center"
          width="100%"
        >
          <Rw1LogoColored height="40px" width="173px" />
          {children}
        </Flex>
      </Flex>
      {footer && <Footer />}
    </VStack>
  )
}
